const currencyCharacters = /[$,\s]/g;

export const parseCurrencyAmount = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  if (typeof value === "number") {
    return value;
  }

  const stringValue = `${value}`.trim();
  const isNegative = stringValue.startsWith("(") && stringValue.endsWith(")");
  const normalizedValue = stringValue
    .replace(currencyCharacters, "")
    .replace(/[()]/g, "");
  const amount = Number(normalizedValue);

  if (Number.isNaN(amount)) {
    return null;
  }

  return isNegative ? -amount : amount;
};

export const getFundAmount = (fund) =>
  parseCurrencyAmount(fund?.rawAmount ?? fund?.amount?.value ?? fund?.amount);

export const hasAuditedCcbfSpending = (funds = [], lastAuditedYear = 0) =>
  (funds ?? []).some(
    (fund) =>
      Number(fund?.year) <= Number(lastAuditedYear) && getFundAmount(fund) > 0
  );
